export enum PaymentStatusEnum {
    Unpaid = 1,// (Sin pagar)
    DepositPaid = 2, //(Seña pagada)
    FullyPaid = 3,// (Pago completo)
    Refunded = 4,// (Reembolsado)
    PartiallyRefunded = 5,// (Parcialmente reembolsado)
}